import React from 'react';
import { Link } from 'react-router-dom';

export default function Wordmark({ className = '' }) {
  return (
    <Link 
      to="/" 
      className={`font-serif italic text-brand-cream font-medium tracking-tight hover:opacity-80 transition-opacity flex items-baseline ${className}`}
    >
      Soon<span className="text-brand-amber font-sans not-italic">.</span>
    </Link>
  );
}